<template>
  <v-tooltip
    class="BaseTooltip"
    id="activator"
    activator="activator"
    location="bottom end"
    max-width="375"
    :open-on-click="true"
  >
    {{ text }}

    <template v-slot:activator="{ props }">
      <button
        v-bind="props"
        type="button"
        class="tooltip-trigger"
        :aria-label="ARIA_LABELS.MORE_INFO"
      >
        <i
          style="font-size: 24px"
          class="icon-information-circle-contained"
          aria-hidden="true"
        />
      </button>
    </template>
  </v-tooltip>
</template>

<script setup lang="ts">
import { ARIA_LABELS } from '@/modules/core/constants/ariaLabels'

interface PropsInterface {
  text: string
}
withDefaults(defineProps<PropsInterface>(), {})
</script>

<style lang="scss" scoped>
.BaseTooltip {
  :deep(> .v-overlay__content) {
    background-color: $color-primary;
    border-radius: $b-radius-2;
  }

}

.tooltip-trigger {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  line-height: 1;
  display: inline-flex;
  align-items: center;
}
</style>
